/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/no-array-index-key */
import {
  Chip,
  Grid,
  InputAdornment,
  // Table,
  // TableBody,
  // TableCell,
  // TableHead,
  // TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import DataTable from './DataTable';
// import { Box } from '@mui/system';

const RobotFindSelectForm = ({
  selected,
  readOnly,
  onDeselect,
  onChange,
  input,
  onSelect,
  list,
  mini,
}) => {
  return (
    <Grid item container sx={{ alignItems: 'center' }} spacing={1}>
      <Grid item xs={12}>
        {selected &&
          selected.map(({ id, serial }) => (
            <Chip
              key={id}
              label={serial}
              color="secondary"
              variant="outlined"
              onDelete={() => onDeselect(id)}
              disabled={readOnly}
              sx={{ mt: 1, ml: 1 }}
            />
          ))}
      </Grid>
      {!mini && !readOnly && (
        <Grid item xs={12}>
          <TextField
            name="group-text-input"
            placeholder="로봇 시리얼, 별칭, 그룹으로 검색하세요."
            value={input || ''}
            onChange={onChange}
            margin="dense"
            size="small"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}
      {mini && (
        <Grid item xs={12}>
          <Typography variant="body1" color="GrayText">
            사용자에게 등록할 로봇을 선택하세요.
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <DataTable
          rows={list}
          columns={[
            { field: 'serial', headerName: '시리얼', width: 140 },
            { field: 'alias', headerName: '별칭', width: 120 },
            {
              field: 'group',
              headerName: '그룹',
              valueGetter: (params) =>
                params.row && params.row.group ? params.row.group.name : '-',
            },
          ]}
          pageSize={5}
          rowsPerPageOptions={[5]}
          headerHeight={40}
          rowHeight={25}
          onRowClick={onSelect}
          height={219}
        />
        {/* <Box
          sx={{
            overflowY: 'scroll',
            overflowX: 'hidden',
            maxHeight: 300,
            width: '100%',
            maxWidth: '600px',
          }}
        >
          
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ py: 1 }}>시리얼</TableCell>
                <TableCell sx={{ py: 1 }}>별칭</TableCell>
                <TableCell sx={{ py: 1 }}>그룹</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {input && list && list.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3}>검색결과가 없습니다.</TableCell>
                </TableRow>
              ) : (
                list &&
                list.map((robot, index) => (
                  <TableRow
                    key={`${robot.serial}_${index}_robot`}
                    onClick={() => onSelect(robot)}
                    className="imagecheck"
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell size="small">{robot.serial || '-'}</TableCell>
                    <TableCell size="small">{robot.alias || '-'}</TableCell>
                    <TableCell size="small">
                      {robot.group ? robot.group.name : '-'}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box> */}
      </Grid>
    </Grid>
  );
};

export default RobotFindSelectForm;
